import {
  ApplicationConfig,
  Proposal,
  ProposalIssueUI,
} from '@lockton-apps/shared/interfaces';
import { defaults, find, kebabCase, map, orderBy, split } from 'lodash';
import { getProposalUrl } from './proposal-url';

export function buildProposalIssuesUI(
  proposal: Proposal,
  config: ApplicationConfig
): ProposalIssueUI[] {
  return orderBy(
    map(proposal?.formData.referrals, (issue, index) => {
      const [stepId] = split(issue.path, '.');
      const stepLabel: string = find(config.steps, {
        id: kebabCase(stepId),
      })?.label as string;

      return defaults(
        {
          label: $localize`Item ${index + 1}`,
          stepLabel,
          stepUrl: getProposalUrl(proposal, kebabCase(stepId)),
        },
        issue
      );
    }),
    ['resolved', 'label'],
    ['asc']
  );
}
